document.addEventListener("DOMContentLoaded", function() {
    // Detectar plantilla special
    var isSpecialTemplate = document.querySelector("[id^='MainProductSpecial-']");
    if (!isSpecialTemplate) return;

    // Función para aplicar estilos dinámicos (inline styles)
    function applySpecialStyles() {
        // Títulos de productos relacionados
        document.querySelectorAll("h2.related-products__heading.inline-richtext.h2").forEach(function(h) {
            h.style.color = "#a2cff0";
        });

        // Pestañas de producto
        document.querySelectorAll(".product-tab").forEach(function(tab) {
            tab.style.color = "#629cc7";

            if (tab.classList.contains("active")) {
                tab.style.setProperty("border-color", "#629CC7", "important");
                tab.style.setProperty("color", "#a2cff0", "important");
            }
        });

        // Logo: ocultar logo normal y mostrar logo alternativo
        var normalLogo = document.querySelector(".header__logo");
        var secondLogo = document.querySelector(".header__second-logo");

        if (normalLogo) normalLogo.style.display = "none";
        if (secondLogo) secondLogo.style.display = "block";
    }

    // Función para insertar estilos CSS con !important
    function injectDynamicStyles() {
        if (document.getElementById("special-dynamic-styles")) return; // Evita duplicados

        var style = document.createElement("style");
        style.id = "special-dynamic-styles";
        style.innerHTML = `
            /* --- Precios --- */
            span.price-item.price-item--sale.price-item--last,
            .card-information > .price,
            span.price-item.price-item--regular {
                color: #a2cff0 !important;
            }

            /* --- Overlay en media de tarjeta --- */
            .card__media::before {
                background: linear-gradient(
                    to bottom,
                    rgb(162 207 240 / 79%) 0%,
                    rgb(255 177 232 / 81%) 100%
                );
            }

            /* --- Accordion headers --- */
            .accordion-header {
                color: #629CC7 !important;
            }

            .accordion-item {
                border-bottom: 2px solid #a2cff0 !important;
            }

            /* --- NUEVOS ESTILOS --- */
            .novedades-wrapper-top {
                background: #a2cff0 !important;
            }

            .text-info {
                color: #a2cff0 !important;
            }

            .__pf.__pf_nukVTotD .pf-a009e23c0414-8_ {
                background-color: #fa84d7 !important; 
            }

            .__pf.__pf_nukVTotD .pf-a009e23c0414-47_ {
                background-color: #fa84d7 !important; 
            }

            .__pf.__pf_nukVTotD .pf-a009e23c0414-49_ {
                background-color: #fa84d7 !important; 
            }

            img.sc-dBFCZX.bInudl.pf-a009e23c0414-7_.pf-image-1.frezzyks.img-footer {
                display: none !important;
            }

            .marshys.img-footer {
                display: block !important;
            }

            /* --- CALL TO ACTION --- */
            .call {
                color: #fffcba !important;
                display: flex !important;
                background: #FFB1E8 !important;
                box-shadow: 8px 8px #fa84d7 !important;
            }

            svg.icon-product.rem path,
            svg.icon-product.pag path,
            svg.icon-product.env path {
                fill: #fffcba !important;
            }
                .header__second-logo {
    display: inline-block !important;
    vertical-align: middle;
    max-height: 60px !important;
    margin-top: -3.5pc;
    margin-left: 91% !important;
}
    header.header.header--middle-center.header--mobile-center.page-width.header--has-menu.header--has-account {
    padding: 12px 20px 0px 20px;
}
    .header__menu-item span {
    color: #629cc7;
}
    .cls-1 {
    fill: #629cc7 !important;
}
    .product__title {
    margin-bottom: 2.5rem !important;
}
    .product__short-description {
    margin-top: 15px;
}
    ul.list-menu.list-menu--inline {
    margin-bottom: -17px;
}
    .header__icons.header__icons--localization.header-localization {
    margin-bottom: -10px;
}
    
     /* --- SOLO EN MÓVIL --- */
  @media screen and (max-width: 749px) {
      .header__second-logo {
                  margin-left: 89% !important;
        max-height: 47px !important;
          margin-top: -2.5pc !important;
      }
          .product-form__input {
    margin: 0 0 2.6rem !important;
}
    header-drawer {
    margin-bottom: -23px;
}
a#cart-icon-bubble {
    margin-bottom: -5px;
}
header.header.header--middle-center.header--mobile-center.page-width.header--has-menu.header--has-account {
    padding: 10px 26px 2px 30px;
}
    summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset svg path {
    fill: #629cc7;
}
    summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset svg {
    margin-top: -7px;
}
    .product span.price-item.price-item--regular {
    font-size: 25px;
}
    .product s.price-item.price-item--regular {
    font-size: 18px;
}
    .caption {
    font-size: 1.2rem !important;
}
        p.stock-message {
        margin-bottom: -34px !important;
    }
        `;
        document.head.appendChild(style);
    }

    // Aplicar estilos al cargar la página
    applySpecialStyles();
    injectDynamicStyles();

    // Observar cambios en el DOM para elementos cargados dinámicamente
    var observer = new MutationObserver(function(mutations) {
        applySpecialStyles();
        injectDynamicStyles();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
